import { CategoryHeader } from "@/components/recipe/CategoryHeader";
import { MultiSelectButton } from "@/components/recipe/MultiSelectButton";
import type { CategoryCatalog, CategoryColor, OptionCategory } from "@/types/recipe";

type Props = {
  title: string;
  category: OptionCategory;
  color: CategoryColor;
  selectedValues: string[];
  onToggle: (option: string) => void;
  catalog: CategoryCatalog;
  large?: boolean;
};

export const CategorySection = ({
  title,
  category,
  color,
  selectedValues,
  onToggle,
  catalog,
  large = false,
}: Props) => (
  <div>
    <CategoryHeader title={title} category={category} large={large} catalog={catalog} />
    <div className="flex flex-wrap gap-2">
      {catalog.getVisibleOptions(category).map((option) => (
        <MultiSelectButton
          key={option}
          option={option}
          isSelected={selectedValues.includes(option)}
          onToggle={() => onToggle(option)}
          category={color}
        />
      ))}
    </div>
  </div>
);
